import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ElectricIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-electric"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M54,34 L14,34 L14,33 C14,31.895 14.895,31 16,31 L52,31 C53.105,31 54,31.895 54,33 L54,34 Z"
          fill="#00000"
          className={styles.defaultColor}
        />
        <polygon fill="#00000" className={styles.defaultColor} points="17 31 19 31 19 27 17 27" />
        <polygon fill="#00000" className={styles.defaultColor} points="33 31 35 31 35 27 33 27" />
        <polygon fill="#00000" className={styles.defaultColor} points="49 32 51 32 51 27 49 27" />
        <polygon fill="#00000" className={styles.defaultColor} points="17 28 27 28 27 26 17 26" />
        <polygon fill="#00000" className={styles.defaultColor} points="41 28 51 28 51 26 41 26" />
        <path
          d="M19.6182 7 25.6912 7C25.7102 7 25.7242 6.982 25.7192 6.964L23.6402.036C23.6352.018 23.6492 0 23.6682 0L28.4992 0C28.5112 0 28.5222.008 28.5262.02L32.4092 12.964C32.4142 12.982 32.4012 13 32.3822 13L27.8322 13C27.8142 13 27.8002 13.018 27.8052 13.035L30.1902 22.18C30.1982 22.21 30.1582 22.229 30.1402 22.203L19.5952 7.044C19.5822 7.026 19.5952 7 19.6182 7M48.3818 7 42.3088 7C42.2898 7 42.2758 6.982 42.2808 6.964L44.3598.036C44.3648.018 44.3508 0 44.3318 0L39.5008 0C39.4888 0 39.4778.008 39.4738.02L35.5908 12.964C35.5858 12.982 35.5988 13 35.6178 13L40.1678 13C40.1858 13 40.1998 13.018 40.1948 13.035L37.8098 22.18C37.8018 22.21 37.8418 22.229 37.8598 22.203L48.4048 7.044C48.4178 7.026 48.4048 7 48.3818 7"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
